import { Typography, useTheme } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import RecommendationResultsSection from './RecommendationResultsSection';

interface Props {
  error: string;
}

const RecommendationResults: FC<Props> = ({ error }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <RecommendationResultsSection title={t('aiRecommendations:results:header')}>
      <Typography
        data-testid="recommendation-results-description"
        fontSize={24}
        lineHeight="150%"
        color={theme.palette.error.main}
      >
        {error}
      </Typography>
    </RecommendationResultsSection>
  );
};

export default RecommendationResults;
